import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/** One narrow column, read top to bottom. */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="py-16">
    <div className="mx-auto max-w-2xl">
      <PartRegion name="gallery" />
      <PartRegion name="main" className="mt-10" />
    </div>
  </StorefrontContainer>
);
